import StudentSidebarLayout from '../../components/StudentSidebarLayout';
import StudentPageTopper from '../../components/StudentPageTopper';
import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../../context/AuthContext';
import { useNavigate, useParams, Link } from 'react-router-dom';
import AttendanceTable from '../../components/student_components/AttendanceTable';
import AttendanceCard from '../../components/student_components/AttendanceCard';
import AccessWrapper from '../../components/AccessWrapper';

export default function Attendance() {
  const { authTokens, user, postPageView, baseUrl } = useContext(AuthContext);
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.studentId;

  /* state variable to hold selected student */
  const [student, setStudent] = useState();
  const [studentSummary, setStudentSummary] = useState();
  const [studentAbsences, setStudentAbsences] = useState();
  const [studentAllAbsences, setStudentAllAbsences] = useState();
  const [studentAbsencesDisplay, setStudentAbsencesDisplay] = useState();
  const [absenceTimeframe, setAbsenceTimeframe] = useState('Current Year');
  const [showingRecentReferrals, setShowingRecentReferrals] = useState(true);
  const [buttonText, setButtonText] = useState('Show All');
  const [loadingCard, setLoadingCard] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);

  useEffect(() => {
    getStudent();
    getStudentSummary();
    getStudentAbsences();
    getStudentAllAbsences();
    postPageView(baseUrl, user.name, user.role, 'student/attendance');
  }, []);

  let getStudent = async () => {
    let response = await fetch(`${baseUrl}/sis/students/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + String(authTokens.access),
      },
    });
    let data = await response.json();

    if (response.status === 200) {
      setStudent(data);
    } else if (response.status === 403) {
      navigate('/unauthorized');
    }
  };

  let getStudentSummary = async () => {
    setLoadingCard(true);
    let response = await fetch(`${baseUrl}/sis/attendance-summary/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + String(authTokens.access),
      },
    });
    let data = await response.json();

    if (response.status === 200) {
      setStudentSummary(data);
      setLoadingCard(false);
    } else if (response.status === 403) {
      setLoadingCard(false);
      navigate('/unauthorized');
    }
  };

  let getStudentAbsences = async () => {
    setLoadingTable(true);
    let response = await fetch(
      `${baseUrl}/sis/attendance/?student_id=${id}&absences=true&recent=true`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    let data = await response.json();

    if (response.status === 200) {
      setStudentAbsences(data?.results);
      setStudentAbsencesDisplay(data?.results);
      setLoadingTable(false);
    } else if (response.status === 403) {
      setLoadingTable(false);
      navigate('/unauthorized');
    }
  };

  let getStudentAllAbsences = async () => {
    let response = await fetch(
      `${baseUrl}/sis/attendance/?student_id=${id}&absences=true`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    let data = await response.json();

    if (response.status === 200) {
      setStudentAllAbsences(data?.results);
    } else if (response.status === 403) {
      navigate('/unauthorized');
    }
  };

  const handleSubmit = () => {
    if (showingRecentReferrals) {
      setStudentAbsencesDisplay(studentAllAbsences);
      setAbsenceTimeframe('All Time');
      setShowingRecentReferrals(false);
      setButtonText('Show Recent');
    } else {
      setStudentAbsencesDisplay(studentAbsences);
      setAbsenceTimeframe('Current Year');
      setShowingRecentReferrals(true);
      setButtonText('Show All');
    }
  };

  return (
    <AccessWrapper
      allowedGroups={[
        'teacher',
        'mtss_member',
        'mtss_supervisor',
        'mtss_admin',
        'district_admin',
      ]}
    >
      <div>
        <StudentSidebarLayout
          propComponents={
            <div>
              <StudentPageTopper student={student} />
              <div className='relative -top-14 mx-auto'>
                <div className='mx-auto px-4 sm:px-6 lg:px-8'>
                  <div className='mx-auto max-w-7xl'>
                    <h1 className='mb-5 text-center text-2xl font-normal text-brandPrimary sm:mb-10 sm:text-3xl'>
                      Current Year Absences
                    </h1>
                    <div className='mx-auto flex flex-row justify-between space-x-8 '>
                      <AttendanceCard
                        loading={loadingCard}
                        data={studentSummary}
                      />
                    </div>
                  </div>
                </div>
                <div className='mx-auto mt-10 bg-gray-100 px-4 pt-4 sm:px-6 lg:px-8'>
                  <div className='mx-auto mt-6 flex w-full max-w-7xl flex-row'>
                    <AttendanceTable
                      loading={loadingTable}
                      data={studentAbsencesDisplay}
                      timeframe={absenceTimeframe}
                    />
                  </div>
                </div>
                <div className='mx-auto bg-gray-100 px-4 pt-5 pb-12 sm:px-6 sm:pb-16 lg:px-8 lg:pb-20'>
                  <div className='mx-auto flex w-full max-w-7xl flex-row justify-end'>
                    <button
                      onClick={handleSubmit}
                      className='rounded-md border border-transparent bg-brandPrimary px-4 py-2 text-base font-medium text-white shadow-sm duration-300 ease-in-out hover:scale-105 hover:bg-brandPrimaryLight focus:outline-none focus:ring-2 focus:ring-brandPrimary focus:ring-offset-2'
                    >
                      {buttonText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
          heading={'Student Report'}
          id={id}
          heading2={'Attendance'}
          attendanceCurrent={true}
        />
      </div>
    </AccessWrapper>
  );
}
